export const changeVolumetricSSMLayerReducer = (state = false, action) => {
  switch (action.type) {
    case "CHANGE_VOLUMETRIC_SSM_Layer":
      return action.payload.volumetricSSMLayer;
    default:
      return state;
  }
};
